import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, Input } from "reactstrap";

//Import Breadcrumb
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import { formatCurrency, formatDate } from '../../Utils/formatters';

const ClaimFundDetails = props => {
  const [modal_Status, setmodal_Status] = useState(false);
  function Status() {
    setmodal_Status(!modal_Status);
    // removeBodyCss();
  }

  const [modal_View, setmodal_View] = useState(false);
  function View() {
    setmodal_View(!modal_View);
    // removeBodyCss();
  }

  const [modal_Status1, setmodal_Status1] = useState(false);
  function Status1() {
    setmodal_Status1(!modal_Status1);
    // removeBodyCss();
  }


  //meta title
  document.title = "Claim Fund Details";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Claim Fund Details")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col xs={12}>
                        <p className="mb-3 border-1">ID : <span className="text-primary">#01 </span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">First Name : <span className="text-primary">Mehul </span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Last Name : <span className="text-primary">Patel </span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Tokens : <span className="text-primary">1500 </span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Currency : <span className="text-primary">MATIC </span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Amount : <span className="text-primary">1122500 MATIC</span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Transaction Details : <span className="text-primary">https://polygonscan.com/tx/0x0f6d1571dc1ba6eac7de09db4d27c70e3ee79d6447a5a0cc683e8780176d99ad</span></p>
                      </Col>
                      <Col xs={12}>
                        <p className="mb-3 border-1">Status	: <span className="text-primary"><span className="font-size-14 badge-soft-success badge bg-success rounded-pill cursor">Approved</span></span></p>
                      </Col>
                      <Col xs={12}>
                        <Link to="/claim_fund" className="btn btn-light">Back</Link>
                      </Col>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={modal_Status} toggle={() => { Status(); }}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={() => { setmodal_Status(false); }} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                {/* <p className="AvailableBalance">Available Balance : <b>€5600</b></p> */}
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select">
                    <option>Pending</option>
                    <option>Approved</option>
                    <option>Cancelled</option>
                  </select>
                </div>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => { setmodal_Status(false); }} aria-label="Close"> Update </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={() => { setmodal_Status(false); }} aria-label="Close">Close</button>
            </div>
          </Modal>


          <Modal className="transation" centered backdrop="static" isOpen={modal_Status1} toggle={() => { Status1(); }}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={() => { setmodal_Status1(false); }} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col xs={12}>
                <div className="mb-3">
                  <label className="form-label">User Polygon MATIC Wallet Address	:</label>
                  <Input name="username" type="text" placeholder="Enter property name" defaultValue="0x1ABC7154748D1CE5144478CDEB574AE244B939B5" />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select">
                    <option>Pending</option>
                    <option>Approved</option>
                    <option>Cancelled</option>
                  </select>
                </div>
              </Col>

              <Col xs={12}>
                <div className="mb-3">
                  <label className="form-label">Transaction Details	:</label>
                  <textarea className="form-control" name="username" type="text" placeholder="Transaction Details" />
                </div>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => { setmodal_Status1(false); }} aria-label="Close"> Submit </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={() => { setmodal_Status1(false); }} aria-label="Close">Close</button>
            </div>
          </Modal>


        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(ClaimFundDetails);
